<template>
  <section
    ref="ad"
    class="ad mx-auto flex justify-center relative select-none w-full overflow-hidden"
  >
    <MajorityUiMajorityLink
      class="absolute w-full h-full z-10"
      tracking-name="communityAdWithoutImage"
      tracking-type="community content"
      :to="url"
    />
    <div
      class="relative text-wrapper flex-grow flex justify-center pl-4 pr-5 py-4 lg:px-12 lg:py-8 uppercase font-druk font-medium text-biggest lg:text-display-12 leading-7 lg:leading-12 tracking-01-em lg:tracking-02-em"
      :class="backgroundText"
    >
      {{ text }}
      <div
        class="absolute right-0 top-0 h-full"
        :class="backgroundButton"
      >
        <div
          class="svg h-full w-5 -ml-px transform scale-105"
          :class="backgroundText"
        />
      </div>
    </div>
    <div
      class="button-wrapper flex flex-grow justify-center items-center"
      :class="backgroundButton"
    >
      <MajorityUiMajorityLink
        class="btn btn-dark z-10 hidden lg:flex"
        tracking-name="communityAdWithoutImage"
        tracking-type="community content"
        :to="url"
        :text="buttonText"
      />
    </div>
  </section>
</template>

<script>
import { isDarkOrLightByElement } from '@/utils/contrast-calculator'
import { BRAND_BACKGROUND_COLORS } from '@/utils/constants'
export default {
  props: {
    buttonText: {
      type: String,
      required: true,
      default: ''
    },
    text: {
      type: String,
      required: true,
      default: ''
    },
    url: {
      type: String,
      required: true,
      default: ''
    },
    backgroundText: {
      type: String,
      default: 'bg-light-green',
      validator: val => BRAND_BACKGROUND_COLORS.includes(val)
    },
    backgroundButton: {
      type: String,
      default: 'bg-pink',
      validator: val => BRAND_BACKGROUND_COLORS.includes(val)
    }
  },
  data () {
    return {
      calculatedTextVariant: 'dark'
    }
  },
  computed: {
    textClass () {
      return this.calculatedTextVariant === 'light'
        ? 'text-white'
        : 'text-dark'
    }
  },
  mounted () {
    this.calculateTextVariant()
  },
  methods: {
    calculateTextVariant () {
      try {
        this.calculatedTextVariant = isDarkOrLightByElement(this.$refs.ad.querySelector('.text-wrapper'))
      } catch (error) {
        this.calculatedTextVariant = 'dark'
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.ad {
    @screen lg {
        max-width: 700px;
    }
}

.button-wrapper {
    min-width: 38px;
    max-width: 15%;

    @screen lg{
        width: 240px;
        max-width: 240px;
    }
}

.svg {
    clip-path: polygon(0 0, 100% 50%, 0 100%);
}
</style>
